import type { CoverageResource } from '@/lib/queries/coverage';

export const MANAGED = '1managed';
export const NOT_MANAGED = '2notManaged';

export const MANAGEMENT_STATUSES = [MANAGED, NOT_MANAGED] as const;
export type ManagementStatus = (typeof MANAGEMENT_STATUSES)[number];

export const getManagementStatus = (
  resource: CoverageResource,
): ManagementStatus => (resource.managed ? MANAGED : NOT_MANAGED);

export const IMPACTS_MANAGED = '1impactsManaged';
export const IMPACTED_BY_UNMANAGED = '2impactedByUnmanaged';

export const IMPACT_ZONES = [IMPACTS_MANAGED, IMPACTED_BY_UNMANAGED] as const;
export type ImpactZone = (typeof IMPACT_ZONES)[number];

export const getImpactZone = ({
  managed,
  impactedBy,
  impacts,
}: CoverageResource): ImpactZone | undefined =>
  managed && impactedBy.filter(({ managed: m }) => !m).length > 0
    ? IMPACTED_BY_UNMANAGED
    : !managed && impacts.filter(({ managed: m }) => m).length > 0
      ? IMPACTS_MANAGED
      : undefined;
